var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2528 31.5425H38.9637C40.0769 31.5425 40.8191 30.8003 40.8191 29.6871V24.1208C40.8191 22.4509 39.5203 20.9665 38.036 20.5954C34.6962 19.6677 29.6865 18.5545 29.6865 18.5545C29.6865 18.5545 27.2744 15.9569 25.6046 14.287C24.6768 13.5448 23.5636 12.9882 22.2648 12.9882H9.27675C8.16349 12.9882 7.23577 13.7303 6.67914 14.658L4.08154 20.0388C3.83584 20.7554 3.71045 21.5078 3.71045 22.2653V29.6871C3.71045 30.8003 4.45262 31.5425 5.56588 31.5425H9.27675",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9877 35.2532C15.0372 35.2532 16.6986 33.5917 16.6986 31.5423C16.6986 29.4928 15.0372 27.8314 12.9877 27.8314C10.9383 27.8314 9.27686 29.4928 9.27686 31.5423C9.27686 33.5917 10.9383 35.2532 12.9877 35.2532Z",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6987 31.5424H27.8313",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5424 35.2532C33.5919 35.2532 35.2533 33.5917 35.2533 31.5423C35.2533 29.4928 33.5919 27.8314 31.5424 27.8314C29.493 27.8314 27.8315 29.4928 27.8315 31.5423C27.8315 33.5917 29.493 35.2532 31.5424 35.2532Z",
    stroke: "#2A2A2A",
    strokeWidth: 3.71087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/park.a8a6c61ee90835056546724a1a4a2e69.svg";
export { ForwardRef as ReactComponent };